import React, { SVGProps } from "react";

export default function StoriesIcon({ color, ...props }: SVGProps<any>) {
  return (
    <svg viewBox="0 0 27 27" width={27} height={27} {...props}>
      <path
        d="M4.5 25.357l-.771-.048a2.24 2.24 0 01-2.086-2.082l-.025-.404a138.681 138.681 0 010-18.587l.025-.403A2.248 2.248 0 013.729 1.77l.403-.024a138.681 138.681 0 0118.587 0l.404.024a2.248 2.248 0 012.062 2.086l.024.404c.415 6.188.415 12.398 0 18.586l-.024.404a2.244 2.244 0 01-2.087 2.066 139.57 139.57 0 01-18.598.04zm3.264-11.815h11.299M7.764 9.507h11.299m-11.299 8.07h11.299"
        fill="none"
        fillRule="evenodd"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.614}
      />
    </svg>
  );
}
